var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "	<div class=\"table-wrapper\">\n		<table class=\"compact\">\n			<tr>\n				<th>Date</th>\n				<th>Name</th>\n				<th>Email</th>\n				<th>Product</th>\n				<th>Payment</th>\n				<th>Shipping</th>\n			</tr>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		</table>\n	</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "				<tr class=\"selectable\">\n					<td><a href=\"/admin/order?id="
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(__default(require("../../../../../common/js/handlebars/formatDate.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.creationDate : depth0),{"name":"formatDate","hash":{},"data":data}))
    + "</a></td>\n					<td><a href=\"/admin/order?id="
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.firstName : depth0), depth0))
    + " "
    + alias2(alias1((depth0 != null ? depth0.lastName : depth0), depth0))
    + "</a></td>\n					<td><a href=\"/admin/order?id="
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.email : depth0), depth0))
    + "</a></td>\n					<td><a href=\"/admin/order?id="
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.quantity : depth0), depth0))
    + "x "
    + alias2(alias1((depth0 != null ? depth0.product : depth0), depth0))
    + "</a></td>\n					<td><a href=\"/admin/order?id="
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\"><span class=\"state state--"
    + alias2(alias1((depth0 != null ? depth0.paymentState : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.paymentState : depth0), depth0))
    + "</span></a></td>\n					<td><a href=\"/admin/order?id="
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\"><span class=\"state state--"
    + alias2(alias1((depth0 != null ? depth0.shippingState : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.shippingState : depth0), depth0))
    + "</span></a></td>\n				</tr>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "	<p>No matching orders found.</p>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,__default(require("../../../../../common/js/handlebars/present.js")).call(alias1,depth0,{"name":"present","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});